import { Outlet } from "react-router-dom";
import CelebrationNavHeader from "../guest/CelebrationNavHeader";
import CelebrationFooter from "../guest/CelebrationFooter";
import { FloatingComparisonButton } from "@/components/shopping/FloatingComparisonButton";
import "@/styles/doughnut-shop.css";

const CustomerLayout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50/30 to-orange-50/30">
      <CelebrationNavHeader />
      <main className="pt-16 sm:pt-20 pb-10">
        <Outlet />
      </main>
      <FloatingComparisonButton />
      <CelebrationFooter />
    </div>
  );
};

export default CustomerLayout;